import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Row, Col } from 'reactstrap';

const Notes = () => {
  return(
    <Row className="notes">
      <Col>
        <div className="title-wrapper">
          <span className="title">Please make sure the size fits you.</span>
        </div>
        <div className="content-wrapper">
          <span>If you unsure regarding your size, please click the size chart button and browse through the chart to find yout correct measurements. For more details, kindly add our Customer Service to consult further.</span>
        </div>
      </Col>
      <Col>
        <div className="title-wrapper">
          <span className="title">Authentic. Guaranteed.</span>
        </div>
        <div className="content-wrapper">
          <span>Every purchase will be meticulously checked in our facilty by our team of experts to ensure the product's authenticity. To find out more about our warranty and refund policy, visit FAQ.</span>
        </div>
      </Col>
    </Row>
  )
}

export default Notes;